jQuery( function ( $ ) {
    'use strict';

});